import { clsx, type ClassValue } from "clsx";
import {
  format,
  isBefore,
  isToday,
  isValid,
  parseISO,
  startOfDay,
} from "date-fns";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function calculateDaysInactive(lastCheckedInAt: string | Date): number {
  const lastCheckedDate = new Date(lastCheckedInAt);
  const now = new Date();

  // Difference in milliseconds
  const diffMs = now.getTime() - lastCheckedDate.getTime();

  // Convert ms to full days
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  return diffDays;
}

export function isDateStringToday(value?: string | null): boolean {
  if (!value) return false;

  const parsedDate = parseISO(value);
  return isValid(parsedDate) && isToday(parsedDate);
}

export function parseCalendarDate(value?: string | null): Date | null {
  if (!value) return null;

  const parsedDate = parseISO(value);
  return isValid(parsedDate) ? startOfDay(parsedDate) : null;
}

export function formatCalendarDate(
  value?: string | null,
  pattern = "MMM d, yyyy",
): string {
  const parsedDate = parseCalendarDate(value);
  return parsedDate ? format(parsedDate, pattern) : "N/A";
}

export function isCalendarDateBeforeToday(value?: string | null): boolean {
  const parsedDate = parseCalendarDate(value);
  return parsedDate ? isBefore(parsedDate, startOfDay(new Date())) : false;
}

export function getInitials(value?: string | null): string {
  return (
    value
      ?.split(" ")
      .map((part) => part[0])
      .filter(Boolean)
      .join("")
      .toUpperCase()
      .slice(0, 2) ?? ""
  );
}

// utils/formatPrice.ts
export function formatPrice(price: number | string): string {
  if (price == null) return ""; // handle null/undefined
  const num = typeof price === "string" ? parseInt(price, 10) : price;
  return num.toLocaleString(); // adds commas automatically
}
